import { adminApiFetch } from './apiService';

export const userService = {
  // TableIndex 使用的標準方法
  getRecords: async (params) => {
    const response = await adminApiFetch('users/get_records', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },

  // 列表 (別名，向後兼容)
  fetchUsers: async (params) => {
    const response = await adminApiFetch('users', { params });
    return response.json();
  },

  // 單一資源
  fetchUser: async (id) => {
    const response = await adminApiFetch(`users/${id}`);
    return response.json();
  },

  // 更新
  updateUser: async (id, data) => {
    const response = await adminApiFetch(`users/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ user: data })
    });
    return response.json();
  },

  // 設定角色
  setRole: async (id, role) => {
    const response = await adminApiFetch(`users/${id}/set_role`, {
      method: 'POST',
      body: JSON.stringify({ role })
    });
    return response.json();
  },

  // 更新權限
  updatePermissions: async (id, permissions) => {
    const response = await adminApiFetch(`users/${id}/update_permissions`, {
      method: 'PATCH',
      body: JSON.stringify({ permissions })
    });
    return response.json();
  },

  // 停用帳號
  disable: async (id) => {
    const response = await adminApiFetch(`users/${id}/disable`, {
      method: 'POST'
    });
    return response.json();
  },

  // 啟用帳號
  enable: async (id) => {
    const response = await adminApiFetch(`users/${id}/enable`, {
      method: 'POST'
    });
    return response.json();
  },

  // 重新產生邀請連結
  regenerateInvitation: async (id) => {
    const response = await adminApiFetch(`user_invitations/${id}/regenerate`, {
      method: 'POST'
    });
    return response.json();
  },

  // 獲取邀請列表
  fetchInvitations: async () => {
    const response = await adminApiFetch('user_invitations');
    return response.json();
  },

  // 建立邀請
  createInvitation: async (data) => {
    const response = await adminApiFetch('user_invitations', {
      method: 'POST',
      body: JSON.stringify(data)
    });
    return response.json();
  },

  // 刪除(取消)邀請
  deleteInvitation: async (id) => {
    const response = await adminApiFetch(`user_invitations/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  }
};

export default userService;
